import { Container, HStack, Link, Stack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import * as React from 'react';
import { Link as RRDLink } from 'react-router-dom';
import { TextBlock } from '../../common/components/TextBlock';
import { ROUTES } from '../../config';
import { ResetPaswordForm } from './components/ResetPasswordForm';

export const ResetPasswordPage = () => {
  return (
    <Container maxW="md">
      <Stack spacing="8">
        <Stack spacing="6" align={'center'} gap={5}>
          <RRDLink to={ROUTES.dashboard}>
            <Image image="logo" w={'300px'} mt={20} cursor={'pointer'} />
          </RRDLink>
        </Stack>
        <ResetPaswordForm />
        <HStack spacing="1" justify="center">
          <TextBlock color="muted">Having issues?</TextBlock>
          <Link colorScheme="blue" href="mailto:help@concreit.com">
            Contact us
          </Link>
        </HStack>
      </Stack>
    </Container>
  );
};
